import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/App';
import reportWebVitals from './reportWebVitals';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';
import { initialiseTranslations } from './locales/initialise';
import msalInstance from './authConfig';
import { MsalProvider } from "@azure/msal-react";

initialiseTranslations();

const rootElem = document.getElementById('root') as HTMLElement;
const root = createRoot(rootElem);

root.render(
  <React.StrictMode>
    <MsalProvider instance={msalInstance}>
      <FluentProvider theme={webLightTheme}>
        <App />
      </FluentProvider>
    </MsalProvider>
  </React.StrictMode>
);

reportWebVitals();